/**
 * QA-492 — 연결 아티스트를 바꾸거나 지울 때 상품의 표시용 아티스트 이름(artistName).
 * BE 는 연결(artistId)을 끊어도 이름은 보존하므로, 지울 때는 "" 로 이름을 지우고, 다른 아티스트를 고르면 null(미전송)로 두어
 * BE 가 그 아티스트 이름으로 채우게 한다.
 */
export const artistNameAfterArtistChange = (nextArtistId: string | null): string | null => (nextArtistId === null ? '' : null);
